import * as React from 'react';

import type {SalesDocumentUpdateInput} from 'nutshell-graphql-types';

import {SaveableWrapper} from '../../saveable-wrapper/saveable-wrapper';

import {QuoteTextArea} from '../editable/quote-text-area';
import {PREPARED_FOR} from '../helpers';
import {QuoteNoteSection} from '../read-only/quote-note-section';

import styles from '../quote.module.css';

type Props = {
    onSave: (arg1: SalesDocumentUpdateInput) => void;
    onCancel: () => void;
    isActive: boolean;
    id: string;
    preparedFor: string;
    onToggleActive: (arg1: string) => void;
    forceSave: boolean;
    isImmutable: boolean;
};

export function QuotePreparedForWrapper(props: Props) {
    const {id, onSave} = props;

    const [preparedFor, setPreparedFor] = React.useState<string>(props.preparedFor);

    React.useEffect(() => {
        setPreparedFor(props.preparedFor);
    }, [props.preparedFor]);

    const handleSave = React.useCallback(() => {
        onSave({
            salesDocument: id,
            preparedFor,
        });
    }, [id, onSave, preparedFor]);

    React.useEffect(() => {
        if (props.forceSave) {
            handleSave();
        }
    }, [props.forceSave, handleSave]);

    const handleCancel = () => {
        setPreparedFor(props.preparedFor);
        props.onCancel();
    };

    return (
        <SaveableWrapper
            isActive={props.isActive}
            onSave={handleSave}
            onCancel={handleCancel}
            onToggleActive={props.onToggleActive}
            sectionName={PREPARED_FOR}
            noPadding={true}
            isImmutable={props.isImmutable}
        >
            {props.isActive ? (
                <div className={styles['editable-text-wrapper']}>
                    <QuoteTextArea
                        value={preparedFor}
                        onChange={setPreparedFor}
                        bottomPaddingForToolbar={true}
                        largerText={true}
                    />
                </div>
            ) : (
                <div className={styles['read-only-text-wrapper']}>
                    <QuoteNoteSection text={preparedFor} />
                </div>
            )}
        </SaveableWrapper>
    );
}
